import { useState } from 'react';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { useAppForm } from 'shared/UI/UIKit/Form';
import { useAppDispatch } from 'shared/services/redux/hooks/use-dispatch';
import { createRegionAction } from 'features/regions/redux/actions';
import type { CreateRegionModalProps } from './types';
import { RegionModalFooter } from '../ModalFooter';
import { RegionForm } from '../../Form/Region';

export const CreateRegionModal = (props: CreateRegionModalProps) => {
  const [form] = useAppForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const hideModal = () => {
    form.resetFields();
    props.hide();
  };

  const onSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);

      dispatch(
        createRegionAction({
          name: values.name,
        }),
      )
        .unwrap()
        .then(() => {
          hideModal();
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const footer = <RegionModalFooter hideModal={hideModal} onSubmit={onSubmit} title="Сохранить" />;
  const content = <RegionForm form={form} />;

  return (
    <AppModal
      visible={props.visible}
      onCancel={hideModal}
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Создать регион"
      maskClosable={false}
    />
  );
};
